import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {tokenResultAtom} from "./entity/Common";
import {loginAdmin} from "../../services/auth/AuthAxios";
import {useForm} from "react-hook-form";
import {RowSpan, TextMainColor, ValidationScript} from "../../assets/GlobalStyles";
import {toast} from "react-toastify";
import styled from 'styled-components'
import {useCookies} from "react-cookie";
import Checkbox from "../../components/common/Checkbox";
import {useAtom} from "jotai";
import {HorizontalRule} from "../../components/common/Common";
import {
  loginAdminParams,
  logo,
  logo_inline_w
} from "../../constants/GlobalConst";

function AdminLogin() {
  const [loginParamsValue, setLoginParams] = useState(loginAdminParams);
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['rememberAdminId'])
  const [isRemember, setIsRemember] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const {register,setValue, handleSubmit, formState: {errors}} = useForm()
  const [,setTokenResult] = useAtom(tokenResultAtom)
  /**
   * 쿠키에 아이디 저장 삭제
   */
  useEffect(() => {
    if(cookies.rememberAdminId !== undefined) {
      setLoginParams({
        ...loginParamsValue,
        email:cookies.rememberAdminId
      })
      setValue('email',cookies.rememberAdminId)
      setIsRemember(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   * 아이디 저장 Cookie 이용
   * @param event
   */
  const handleChangeRemember = (event) => {
    setIsRemember(event.target.checked)
    if(event.target.checked) {
      setCookie('rememberAdminId', loginParamsValue.email)
    } else {
      removeCookie('rememberAdminId')
    }
  }

  /**
   * 관리자 이메일(아이디)입력
   * @param event
   */
  const handleChangeId = (event) => {
    setLoginParams({
      ...loginParamsValue,
      email: event.target.value
    })
    setValue('email',event.target.value)
    if(isRemember){
      setCookie('rememberAdminId', event.target.value)
    }
  }
  /**
   * 관리자 패스워드
   * @param event
   */
  const handleChangePassword = (event) => {
    setLoginParams({
      ...loginParamsValue,
      password: event.target.value
    })
  }
  /**
   * 관리자 로그인
   */
  const onSubmit = () => {
    loginAdmin(loginParamsValue).then((response) => {
      if (response) {
        setTokenResult({
          id:response.email,
          role:response.role,
          name:response.name,
          accessToken: response.token.accessToken,
          refreshToken: response.token.refreshToken
        })
        navigate('/board/dashboard')
      } else {
        toast.info('아이디와 비밀번호를 확인해 주세요.')
      }
    });
  }
  const onError = (error) => console.log(error)
  return (
    <>
      <LoginContainer>
        <div>
          <div>
            <LoginLogo/>
            <div>
              <>
                <div>로그인 하시면 Oaple의</div>
                <div>다양한 서비스를 이용하실 수 있습니다.</div>
              </>
            </div>
          </div>
        </div>
        <div>
          <LoginInputComponent>
            <Title>
              <h1><BlockLogo/></h1>
            </Title>
            <RowSpan style={{justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
              <Link to={'/'}>사용자로그인</Link>
              <HorizontalRule />
              <TextMainColor>관리자 로그인</TextMainColor>
            </RowSpan>
            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <InputGroup>
                <LabelInline>
                  <span>아이디</span>
                  <Checkbox
                    onChange={handleChangeRemember}
                    isChecked={isRemember}
                    label={'아이디 저장'}
                    type={'a'}/>
                </LabelInline>
                <div>
                  <input
                    type={'text'}
                    placeholder={'이메일 아이디'}
                    value={loginParamsValue.email || ''}
                    {...register('email', {
                      required: "아이디를 입력해주세요",
                      onChange: (e) => {
                        handleChangeId(e)
                      }
                    })}/>
                </div>
                {errors.email && <ValidationScript>{errors.email.message}</ValidationScript>}
              </InputGroup>
              <InputGroup>
                <LabelInline>
                  <span>비밀번호</span>
                </LabelInline>
                <div style={{position: 'relative'}}>
                  <input
                    type={!showPassword ? 'password' : 'text'}
                    placeholder={'비밀번호(8~12자)'}
                    maxLength={16}
                    value={loginParamsValue.password || ''}
                    {...register("password", {
                      required: "비밀번호를 입력해주세요",
                      pattern: {
                        value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/,
                        message: "비밀번호를 확인해주세요. 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)"
                      },
                      onChange:handleChangePassword
                    })}/>
                  <ShowPassword
                    style={showPassword ? {backgroundImage: "url('/assets/images/login/hide.png')"} : {backgroundImage: "url('/assets/images/login/show.png')"}}
                    onClick={() => setShowPassword(!showPassword)}/>
                </div>
                {errors.password && <ValidationScript>{errors.password?.message}</ValidationScript>}
              </InputGroup>
              <InputGroup>
                <Button type={'submit'}>
                  로그인
                </Button>
              </InputGroup>
            </form>
          </LoginInputComponent>
        </div>
      </LoginContainer>

    </>
  )
}

export default AdminLogin;

const LoginContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f6f8;  

  & > div:first-child {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48%;
    min-height: 100vh;
    overflow: hidden;
    background:
      radial-gradient(circle at 18% 18%, rgba(255,255,255,.16) 0 80px, transparent 81px),
      radial-gradient(circle at 82% 78%, rgba(255,255,255,.1) 0 150px, transparent 151px),
      linear-gradient(rgb(32, 36, 43) 0%, rgb(25, 28, 34) 100%);
    text-align: center;

    &::after {
      position: absolute;
      right: -90px;
      bottom: -110px;
      width: 330px;
      height: 330px;
      border: 1px solid rgba(255,255,255,.16);
      border-radius: 50%;
      content: "";
    }

    & > div {
      position: relative;
      z-index: 1;
    }

    & div > div:last-child {
      margin-top: 14px;

      & div {
        color: rgba(255,255,255,.9);
        font-size: var(--font-size-14);
        line-height: 1.7;
      }
    }
  }

  & > div:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52%;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 34px;
  }

  @media (max-width: 860px) {
    & > div:first-child {
      display: none;
    }

    & > div:last-child {
      width: 100%;
      padding: 20px;
    }
  }
`

const Title = styled.div`
  text-align: center;
  & h1 {
    margin: 0 0 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const LoginLogo = styled.div`
  width: 250px;
  height: 92px;
  background-image: url(${logo_inline_w});
  background-image: -webkit-image-set(url(${logo_inline_w}) 1x, url(${logo_inline_w}) 2x, url(${logo_inline_w}) 3x);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const BlockLogo = styled.div`
  width: 128px;
  height: 58px;
  background-image: url(${logo});
  background-image: -webkit-image-set(url(${logo}) 1x, url(${logo}) 2x, url(${logo}) 3x);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const LoginInputComponent = styled.div`
  width: min(100%, 390px);
  box-sizing: border-box;
  padding: 32px 34px 30px;
  border-top: 7px solid #1c2027;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 34px rgba(31, 41, 55, 0.08);

  & > div:nth-child(2) {
    min-height: 34px;
    margin-bottom: 10px;
  }

  & > div:nth-child(2) a,
  & > div:nth-child(2) span {
    font-size: var(--font-size-12);
    text-decoration: none;
  }

  @media (max-width: 480px) {
    padding: 26px 22px;
  }
`

const InputGroup = styled.div`
  position: relative;
  margin: 18px 0 0;

  & input[type='text'], input[type='email'], input[type='password'] {
    width: 100%;
    height: 42px;
    box-sizing: border-box;
    padding: 0 13px;
    border: 1px solid #dfe3e7;
    background-color: #fff;
    border-radius: 7px;
    color: #30363d;
    font-family: inherit;
    font-size: var(--font-size-13);
    outline: 0;
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  & input:focus {
    border-color: #f5811f;
    box-shadow: 0 0 0 3px rgba(245,129,31,.1);
  }

  & input[type='checkbox'] + label {
    font-size: var(--font-size-12);
    color: #777
  }
`

const Button = styled.button`
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #f5811f;
  border-radius: 7px;
  color: #fff;
  background-color: #f5811f;
  font-family: inherit;
  font-size: var(--font-size-14);
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(245,129,31,.2);
  transition: background-color .15s ease, transform .15s ease;

  &:hover {
    background-color: #df7017;
    transform: translateY(-1px);
  }
`

const LabelInline = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  color: #454c53;
  font-size: var(--font-size-13);
  font-weight: 700;
`
const ShowPassword = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 42px;
  height: 42px;
  background-image: url('/assets/images/login/hide.png');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  cursor: pointer;
`
